<template>
  <div class="container">
    <div class="header-panel side-gap">
      <template v-for="item in items">
        <template v-if="item.href">
          <BorderlessButton :href="item.href" :key="item.icon">
            <IconText :icon="item.icon" :text="item.text"/>
          </BorderlessButton>
        </template>
        <template v-else>
          <IconText :key="item.icon" :icon="item.icon" :text="item.text"/>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import contacts from "@/cfg/contacts";
import BorderlessButton from "@/components/BorderlessButton";
import IconText from "@/components/IconText";

export default {
  name: 'Header',
  components: {
    BorderlessButton,
    IconText,
  },
  data() {
    return {
      items: contacts,
    }
  },
}
</script>

<style lang="scss" scoped>

.container {
  font-weight: 600;

  display: flex;
  flex-direction: column;
  justify-content: center;

  height: 50px;
  background-color: $bg-color-1;

  .header-panel {
    display: flex;
    gap: 16px;
    flex-flow: row-reverse;
  }
}

</style>
